exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress-bar[data-v-e7c0e756] {\n  width: 100%;\n  height: 4px;\n  position: fixed;\n  z-index: 101;\n  top: 60px;\n  display: grid;\n  grid-gap: 2px;\n}\n.progress-bar .step[data-v-e7c0e756] {\n  transition: background-color 0.8s ease-out;\n  background-color: #efefef;\n}\n.progress-bar .step--completed[data-v-e7c0e756] {\n  background-color: #f2c0de;\n}", ""]);

// exports
